import { Store as PullStateSTore } from "pullstate";
import { Config, Session } from "./__generated__/graphql";
import env from "./env.json";

interface StoreTypes {
  config?: Config;
  session?: Session;
  player: any;
  env: any;
  cookies: any;
  isMobile: boolean;
}

export const Store = new PullStateSTore<StoreTypes>({ env, session: undefined, config: undefined, player: {}, cookies: {}, isMobile: false });
export const PlayerStore = new PullStateSTore({ tracklist: [], position: 0 });
